__turbopack_context__.v({
  "blueskyIcon": "shareComboButtons-module-scss-module___314Fa__blueskyIcon",
  "copyIcon": "shareComboButtons-module-scss-module___314Fa__copyIcon",
  "facebookIcon": "shareComboButtons-module-scss-module___314Fa__facebookIcon",
  "linkIcon": "shareComboButtons-module-scss-module___314Fa__linkIcon",
  "redditIcon": "shareComboButtons-module-scss-module___314Fa__redditIcon",
  "shareContainer": "shareComboButtons-module-scss-module___314Fa__shareContainer",
  "shareNetwork": "shareComboButtons-module-scss-module___314Fa__shareNetwork",
});
